// extracted by mini-css-extract-plugin
module.exports = {"copyright":"pureflo_copyright__pA2qc","paragraph":"pureflo_paragraph__2xgeU","link":"pureflo_link__3Lj5a"};